import script from "./AboutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutView.vue?vue&type=script&lang=ts&setup=true"

import "./AboutView.vue?vue&type=style&index=0&id=54dd68cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54dd68cc"]])

export default __exports__